import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';

import InstagramUserInfo from '@/components/RecentFollow/InstagramUserInfo';
import { fetchInsMonitorSearch } from '@/lib/service/home';
import { InsAccountModel } from '@/types/home';

interface InstagramAccountInfoProps {
  mediaName?: string;
  onInfoChange?: (info: InsAccountModel | undefined) => void;
}

const InstagramAccountInfo: React.FC<InstagramAccountInfoProps> = ({ mediaName, onInfoChange }) => {
  const { t } = useTranslation();
  const [innerAccountInfo, setInnerAccountInfo] = useState<InsAccountModel>();

  const initComponentData = useCallback(async () => {
    if (!mediaName) {
      return;
    }
    try {
      const res = await fetchInsMonitorSearch(mediaName, undefined);
      setInnerAccountInfo(res.data[0]);
      onInfoChange?.(res.data[0]);
    } catch (error) {
      console.error(error);
    }
  }, [mediaName]);

  useEffect(() => {
    initComponentData();
  }, [initComponentData]);

  return (
    <div className="flex items-center justify-center gap-8 mt-8 max-md:flex-col max-md:gap-4 max-md:mt-5">
      {innerAccountInfo && (
        <InstagramUserInfo
          currentInsUser={innerAccountInfo}
          hidePrivateMark
          className="mt-0 max-md:items-center"
          avatarClassName="w-12 h-12 max-md:w-12 max-md:h-12"
          fullNameClassName="max-md:text-[1.5rem] max-md:leading-7"
        />
      )}
      <div className="flex items-center gap-8 text-base max-md:text-sm">
        <div className="space-x-1">
          <span className="font-medium">{innerAccountInfo?.media_count}</span>
          <span className="text-[#0C0C0C]/60">{t('Post')}</span>
        </div>
        <div className="space-x-1">
          <span className="font-medium">{innerAccountInfo?.follower_count}</span>
          <span className="text-[#0C0C0C]/60">{t('Followers')}</span>
        </div>
        <div className="space-x-1">
          <span className="font-medium">{innerAccountInfo?.following_count}</span>
          <span className="text-[#0C0C0C]/60">{t('Following')}</span>
        </div>
      </div>
    </div>
  );
};

export default InstagramAccountInfo;
